import { Component, Input } from '@angular/core';
import { ICategory, DoodProductModel } from '@core/models/product.model';
import { CategoryKeys } from '@config/keys/category.keys';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { ProductPushV2AtomHoverColors } from '@shared/interfaces/product-hover-colors.interface';
import { PRODUCT_STORE_COMPONENT_ACTIONS } from '@store/product/product.action';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';

@Component({
  selector: 'app-product-category-cards-with-name-atom',
  templateUrl: './product-category-cards-with-name-atom.component.html',
  standalone: false,
})
export class ProductCategoryCardsWithNameAtomComponent {
  @Input() displayContext = '';
  @Input() category!: ICategory;
  @Input() products!: DoodProductModel[];
  @Input() isOrderingAllowed = true;
  @Input() level?: number;
  @Input() categoryNameColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() categoryDescriptionColor: IContentBuilderFieldColor = {
    value: 'neutral-600',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productNameColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productDescriptionColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productPriceColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  };
  @Input() productImagePlaceholderColor: IContentBuilderFieldColor = {
    value: 'neutral-50',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productBorderColor: IContentBuilderFieldColor = {
    value: 'neutral-100',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productBackgroundColor: IContentBuilderFieldColor = {
    value: 'transparent',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productHoverColors?: ProductPushV2AtomHoverColors;
  @Input({ required: true }) tagColors!: ContentBuilderFieldColors;

  categoryKeys = CategoryKeys;

  private readonly store = inject(Store);

  protected requestGoToProduct(product: DoodProductModel): void {
    this.store.dispatch(
      PRODUCT_STORE_COMPONENT_ACTIONS.selectProduct({
        productId: product.id,
        productShopId: product.shop_id,
        productOrigin: {
          channel: 'catalog',
          reference: `category_${this.category.id}`,
        },
      }),
    );
  }
}
